// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

// Element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

/* 路由 */
import router from './router'
import store from './store/index.js'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* bootstrapValidator */
import './assets/css/bootstrapValidator.min.css'
import './assets/js/bootstrapValidator.min'

/* 重置字体样式 */
import './assets/css/font.css'

/* jquery.eeyellow.Timeline */
import './assets/css/jquery.eeyellow.Timeline.css'
import './assets/js/jquery.eeyellow.Timeline.js'

/* MyNav.css */
import './assets/css/MyNav.css'

/* 重置字体样式 */
import './assets/css/common.less'

// 单独引用animate.css
import 'animate.css/animate.min.css' //引入

/* wow.js */
// import "animate.css"
// import "wowjs/css/libs/animate.css"// 巨坑... 此地方要引入两个css
// import wow from 'wowjs'
// Vue.prototype.$wow = wow

/* videojs */
import videojs from "video.js";
import "video.js/dist/video-js.css";
Vue.prototype.$video = videojs;

/* 引入aos动画库相关文件 */
// import AOS from 'aos';
// import 'aos/dist/aos.css';

/* 头部组件 */
// import Header from './components/Header'
// Vue.component(Header.name, Header)

import Header2 from './components/Header2'
Vue.component(Header2.name, Header2)

import Header3 from './components/Header3'
Vue.component(Header3.name, Header3)

import BannerTitle from './components/yd_title.vue'
Vue.component(BannerTitle.name, BannerTitle)

/* 导航组件 */
import MyNav from './components/MyNav.vue'
Vue.component(MyNav.name, MyNav)

/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

import Footer2 from './components/Footer2'
Vue.component(Footer2.name, Footer2)

import Footer3 from './components/Footer3'
Vue.component(Footer3.name, Footer3)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

/* line */
import DivisionLine from './components/DivisionLine'
Vue.component(DivisionLine.name, DivisionLine)

/*vue-amap*/
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'your amap key',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

//layer 弹窗
import layer from 'layui-layer';
Vue.prototype.$layer = layer;

//图片懒加载
import VueLazyload from 'vue-lazyload'
const loadimage = require('./assets/img/loading.png')

Vue.use(VueLazyload, {
  preLoad: 1.3, //预加载的宽高比
  loading: loadimage, //图片加载状态下显示的图片
  // error: errorimage, //图片加载失败时显示的图片
  attempt: 1, // 加载错误后最大尝试次数
})

Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js